'use client';

import { useState, useEffect } from 'react';
import SupportHero from './SupportHero';
import SupportCategories from './SupportCategories';
import FAQSection from './FAQSection';
import ContactForm from './ContactForm';
import SupportResources from './SupportResources';
import SupportTeam from './SupportTeam';
import EmergencyPopup from './EmergencyPopup';
import AskWingsBot from './AskWingsBot';
import Icon from '@/components/ui/AppIcon';

export default function SupportInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [emergencyOpen, setEmergencyOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleContactClick = () => {
    if (isHydrated) {
      const contactSection = document.getElementById('contact-form');
      contactSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCategorySelect = (categoryId: string) => {
    if (isHydrated) {
      console.log('Selected category:', categoryId);
      const contactSection = document.getElementById('contact-form');
      contactSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-96 bg-card"></div>
          <div className="max-w-7xl mx-auto px-6 py-20 space-y-8">
            <div className="h-64 bg-card rounded-xl"></div>
            <div className="h-64 bg-card rounded-xl"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SupportHero
        onContactClick={handleContactClick}
        onEmergencyClick={() => setEmergencyOpen(true)}
        onChatClick={() => setChatOpen(true)}
      />
      <SupportCategories onCategorySelect={handleCategorySelect} />
      <FAQSection />
      <div id="contact-form">
        <ContactForm />
      </div>
      <SupportResources />
      <SupportTeam />

      {/* Emergency Support Popup */}
      <EmergencyPopup
        isOpen={emergencyOpen}
        onClose={() => setEmergencyOpen(false)}
      />

      {/* AskWings AI Bot */}
      <AskWingsBot
        isOpen={chatOpen}
        onClose={() => setChatOpen(false)}
      />

      {/* Floating Chat Button */}
      {!chatOpen && (
        <button
          onClick={() => setChatOpen(true)}
          className="fixed bottom-6 right-6 z-40 group flex items-center space-x-3 px-4 py-3 bg-accent text-primary font-cta text-sm font-bold rounded-2xl shadow-glow hover:bg-accent/90 transition-all duration-300 hover:-translate-y-1"
        >
          <div className="relative">
            <Icon name="CpuChipIcon" size={20} />
            <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-400 rounded-full border border-primary" />
          </div>
          <span>AskWings AI Bot</span>
        </button>
      )}
    </>
  );
}